import MaxWidthContainer from "./MaxWidthContainer";

export default MaxWidthContainer;
